module.exports = __webpack_public_path__ + "static/img/right-home-row-2.bb695936.webp";